<template>
    <div class="container-fluid root-component">
        <div id="main_spinner" v-show="$root.loading || data_loading" class="spinner">
            <span class="spinner-border spinner-border-sm margin-right5" role="status" aria-hidden="true"></span>
        </div>

        <div class="row justify-content-center">
            <div class="col mx-1 element-container">
                <router-view></router-view>
                <notifications class="custom-notification"></notifications>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        created() {
            event_bus.$on('loading', (value) => {
                this.data_loading = value;
                this.$root.loading = value;
            });
        },
        data() {
            return {
                data_loading:null
            }
        },
        methods: {

        }
    }
</script>
<style lang="scss" scoped>
    @import '~@/_variables.scss';
    .spinner {
        position: fixed;
        width: 100%;
        height: 100%;
        text-align: center;
        background-color: $body-bg;
        z-index: 1000;
        left: 0;

        .spinner-border {
            position: relative;
            top: 40%;
            width: 3rem;
            height: 3rem;
            color: #36a8cd;
        }
    }
    div.root-component{
        @media screen and (max-width: 768px) {
            margin-left:0;
            margin-right:0;
            padding-left:0;
            padding-right:0;
        }
    }
    div.element-container{
        @media screen and (max-width: 768px) {
            margin-left:-3rem !important;
            margin-right:-3rem !important;
            padding-left:0 !important;
            padding-right:0 !important;
        }
    }
</style>